export default __webpack_public_path__ + "static/media/CW__2949[cw].034ce450.jpg";